import { RolUsuarioAplicacion } from "src/Models/RolUsuarioAplicacion";
import { Tabla } from "../services/bd/Tablas/tablas.service";

/*
    * Deribado de la clase RolUsuarioAplicacion
    * Define las propiedades específicas del rol de CallCenter
    * piloto:Establece si se debe de cargar un piloto previo (el número de piloto)
    * token_buscador: establece el token a usar en el buscador de artículos
    *  - Si es false, no se permite la búsqueda de artículos o se usará el propio del usuario
*/
export class RolCallCenter extends RolUsuarioAplicacion
{
    public piloto:string[] = [];
    public token_buscador:string|boolean = false;
    public showBotones : {[key: string]: boolean} = {};
    constructor(piloto:string[], token_buscador=false,showBtn = {},rol?:RolUsuarioAplicacion)
    {
        super();
        this.piloto = piloto;
        this.token_buscador = token_buscador;
        this.showBotones = showBtn;
        if(rol)
        {
            this.nombre_rol = rol.nombre_rol;
            this.datos_carga = rol.datos_carga;
        }
    }
}

export { RolUsuarioAplicacion };